module.exports = __webpack_public_path__ + "right-arrow.svg?90ad793657e6601cef11b0ae1af0129e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/right-arrow.svg
// module id = 136
// module chunks = 0